import React, { useContext } from 'react';
import { NavLink, Outlet, Navigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { user } = useContext(UserContext);
  
  // Check if user is admin (role 2 or higher)
  const isAdmin = user && user.role >= 2;
  
  // If not admin, redirect to home page
  if (!isAdmin) {
    return <Navigate to="/" />;
  }
  
  return (
    <div className="admin-dashboard">
      <h1>Admin Management</h1>
      <div className="admin-menu">
        <NavLink to="manage-home" className="admin-menu-item">Manage Home Page</NavLink>
        <NavLink to="manage-users" className="admin-menu-item">Manage Users</NavLink>
        <NavLink to="manage-characters" className="admin-menu-item">Manage Characters</NavLink>
        <NavLink to="manage-deeds" className="admin-menu-item">Manage Deeds</NavLink>
        <NavLink to="manage-skills" className="admin-menu-item">Manage Skills</NavLink>
        <NavLink to="manage-quests" className="admin-menu-item">Manage Quests</NavLink>
        <NavLink to="manage-cities" className="admin-menu-item">Manage Cities</NavLink>
        <NavLink to="manage-guilds" className="admin-menu-item">Manage Guilds</NavLink>
        <NavLink to="manage-chat" className="admin-menu-item">Manage Chat</NavLink>
        <NavLink to="manage-ticker" className="admin-menu-item">Manage Ticker Feed</NavLink>
      </div>
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminDashboard;
